// extracted by mini-css-extract-plugin
export default {"cContainer":"styles_cContainer__B-quZ","form":"styles_form__IoAda"};